<template>
<div class='hs-table'>
  <el-table
    ref='table'
    v-show='data && data.length'
    v-bind='elProps'
    :data='data'
    v-on='$listeners'
    width='100%'
  >
    <template v-for='(col, i) in tableColumns'>
      <hs-table-column v-if='col.checked' :key='i' :col='col'></hs-table-column>
    </template>
  </el-table>

  <div v-show="!data || !data.length" class='no-data'>
    <span> {{ emptyText || t('no data') }} </span>
  </div>

  <template v-if='data && data.length && showColumnSetting'>
    <el-popover
      placement="left-start"
      width="160"
      v-model="visible"
      :visible-arrow='false'
    >
      <el-tree
        ref='tree'
        :data='tableColumns'
        node-key='id'
        :default-checked-keys="defaultCheckedKeys"
        @check="updateCheckedKeys"
        show-checkbox>
      </el-tree>
      
      <div style="text-align: right; margin-top: 20px;">
        <el-button
          type="primary"
          size='mini'
          :disabled='checkedKeys.length === 0'
          @click="updateTableColumns"
        > {{ t('confirm') }} </el-button>
      </div>
      <span class='column-setting' slot="reference">
        <i class='el-icon-arrow-left'></i>
      </span>
    </el-popover>
  </template>
</div>
</template>

<script>
import HsTableColumn from './TableColumn';
import Locale from '../../mixins/locale';

const initColumns = (() => {
  let id = 0
  const initCol = col => ({
    ...col,
    id: 'col-' + id++,
    checked: true,
    label: col.label || '--',
    children: col.children && col.children.length ? initColumns(col.children) : null
  })

  return columns => columns.map(c => initCol(c))
})()

const eachTreeNode = (tree, cb) => {
  tree.forEach(node => {
    cb(node)
    node.children && eachTreeNode(node.children, cb)
  })
}

export default {
  name: 'HsTable',
  components: { HsTableColumn },
  mixins: [Locale],
  props: {
    /**
     * 表格数据
     */
    data: Array,
    /**
     * 表格列配置数据
     * 
     * 列设置对象为 ElTableColumn 的属性配置对象；如果设置了列的
     * component 属性则会将 component 对应的组件放在列的插槽中，
     * 同时将data传入的row对象作为prop传递给该组件；
     * 当设定component字段时，可以通过handlers字段绑定自定义列的事件处理函数
     */
    columns: Array,
    /**
     * ElTable 组件的属性配置对象；
     */
    elProps: Object,
    /**
     * 是否显示列设置菜单
     */
    showColumnSetting: {
      type: Boolean,
      default: false
    },
    /**
     * 暂无数据的文本提示
     */
    emptyText: {
      type: String,
    }
  },
  data () {
    const columns = initColumns(this.columns)
    const defaultCheckedKeys = columns.map(n => n.id);
    return {
      visible: false,
      tableColumns: columns,
      defaultCheckedKeys,
      checkedKeys: [...defaultCheckedKeys]
    }
  },
  methods: {
    updateCheckedKeys (node, checked) {
      this.checkedKeys = checked.checkedKeys;
    },
    updateTableColumns () {
      const checkedKeys = this.$refs.tree.getCheckedKeys(false, true);
      
      eachTreeNode(
        this.tableColumns, 
        node => node.checked = checkedKeys.includes(node.id)
      )

      this.visible = false;
    },

    doLayout () {
      if (this.$refs.table) {
        this.$refs.table.doLayout()
      }
    }
  },
  watch: {
    columns () {
      const columns = initColumns(this.columns)
      const defaultCheckedKeys = columns.map(n => n.id);
      this.tableColumns = columns;
      this.defaultCheckedKeys = defaultCheckedKeys;
      this.checkedKeys = [...defaultCheckedKeys];
    }
  }
}
</script>

<style scoped lang='scss'>
.hs-table {
  position: relative;
  .column-setting {
    position: absolute;
    right: 0;
    top: 10px;
    background: #f0f0f0;
    color: #aaa;
    line-height: 40px;
    cursor: pointer;
    clip-path: polygon(0 20%, 100% 0, 100% 100%, 0 80%);
  }
}
.no-data {
  position: relative;
  width: 100%;
  min-height: 400px; 
  background-image: url(../../assets/no_data.png);
  background-repeat: no-repeat;
  background-size: 402px 333px;
  background-position: 50% 50%;
  color: #585B61;
  font-size: 16px;
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 100px);
  }
}
</style>